// @ts-ignore
import { UserStore } from "@/stores/userStore";

const MoviePageView = () =>
  // @ts-ignore
  import(/*webpackChunkName: "MoviePageView"*/ "@/views/tittle/MoviePage.vue");

// @ts-ignore
const MoviePageAppView = () =>
  import(
    // @ts-ignore
    /*webpackChunkName: "MoviePageAppView"*/ "@/views/app/MoviePageApp.vue"
  );

const baseRoute = {
  path: "peliculas/:slug",
  name: "peliculas",
  alias: ["movies/:slug", "pelicula/:slug", "movie/:slug"],
  component: MoviePageView,
  meta: {
    requiresAuth: false,
    requiresEntitlement: false,
    isAmbiguous: true,
  },
  beforeEnter: (to: any, from: any, next: any) => {
    const userStore = UserStore();
    if (userStore.isEntitled && userStore.isLoggedIn) {
      to.matched[1].components.default = MoviePageAppView;
    } else {
      to.matched[1].components.default = MoviePageView;
    }
    next();
  },
};

export const movie = {
  ...baseRoute,
  props: (route: { params: { slug: any } }) => ({
    slug: route.params.slug,
    type: "movie",
  }),
};

export const serie = {
  ...baseRoute,
  path: "series/:slug",
  name: "series",
  alias: ["serie/:slug"],
  props: (route: { params: { slug: any } }) => ({
    slug: route.params.slug,
    type: "series",
  }),
};

export default baseRoute;
